import React, { useMemo, useState } from 'react';
import ApplicationLogo from '@/Components/ApplicationLogo';
import Dropdown from '@/Components/Dropdown';
import NavLink from '@/Components/NavLink';
import ResponsiveNavLink from '@/Components/ResponsiveNavLink';
import { Link } from '@inertiajs/inertia-react';
import Select from 'react-select'
import { Inertia } from '@inertiajs/inertia';
import Accordion from '@/Components/Accordion/Accordion';

export default function Authenticated({ auth, header, children, store, branchOffice, branchOffices, isValidator }) {
    const [showingNavigationDropdown, setShowingNavigationDropdown] = useState(false);
    //console.log('branchoffice', branchOffice)
    const isCashboxValidator = useMemo(() => {
        return Boolean(auth.user.roles.find(e => e.name === 'cashbox'))
    }, [auth.user.roles]);

    const isSuperAdmin = useMemo(() => {
        return Boolean(auth.user.roles.find(e => e.name === 'super_admin'))
    }, [auth.user.roles]);

    const isAdmin = useMemo(() => {
        return Boolean(auth.user.roles.find(role => role.name === 'admin' || role.name === 'super_admin'))
    }, [auth.user.roles]);

    const isCashboxOperator = useMemo(() => {
        return Boolean(auth.user.roles.find(role => role.name === 'cashbox_operator' || role.name === 'super_admin'))
    }, [auth.user.roles]);

    const links = [
        {
            title: 'Dashboard',
            href: route('dashboard'),
        },
        {
            title: 'Cupones',
            href: branchOffice ? route('coupons.index', { office: branchOffice?.slug }) : '',
            canBeSeenIf: Boolean(branchOffice?.slug) && isAdmin && isSuperAdmin,
        },
        {
            title: 'Productos',
            href: route('products.index'),
            canBeSeenIf: Boolean(branchOffice?.slug) && isSuperAdmin
        },
        {
            title: 'Ventas',
            dropdown: [
                {
                    title: 'Ventas diarias',
                    href: branchOffice ? route('order.daily', { office: branchOffice?.slug }) : '',
                    canBeSeenIf: Boolean(branchOffice?.slug)
                },
                {
                    title: 'Ventas mensuales',
                    href: branchOffice ? route('order.summary', { office: branchOffice?.slug }) : '',
                    canBeSeenIf: Boolean(branchOffice?.slug)
                },
                {
                    title: 'Reporte de ventas',
                    href: route('export.sales.index'),
                    canBeSeenIf: isSuperAdmin
                },
            ],
            canBeSeenIf: isAdmin,
        },
        {
            title: 'Extras',
            dropdown: [
                {
                    title: 'Venta manual',
                    href: (auth.user?.branch_office && !isSuperAdmin) ?
                        route('branch-office.manual-sale.index', {office: auth.user.branch_office?.slug})
                        :
                        branchOffice ? route('branch-office.manual-sale.index', {office: branchOffice?.slug}) : '',
                },
                {
                    title: 'Venta empresa',
                    href: route('bulk-sales.index'),
                    canBeSeenIf: isSuperAdmin
                }
            ],
            canBeSeenIf: Boolean(branchOffice?.slug) && isCashboxOperator
        }
    ]

    const LinkList = () => {
        return links.map((link, i) => {
            const isDropdown = link.hasOwnProperty('dropdown');
            const method = link?.method || 'get';

            const canBeSeenIf = link.canBeSeenIf === undefined ? true : link.canBeSeenIf;

            return canBeSeenIf && (
                isDropdown ? (
                    <React.Fragment key={`accordion-${i}`}>
                        <div className="block sm:hidden sm:flex px-4 py-2 sm:px-0 sm:py-0">
                            <Accordion>
                                <Accordion.Panel className="gap-2 items-center text-gray-500" title={link.title}>
                                    <Accordion.Content>
                                        {link.dropdown.filter((canBeSeenIf) => canBeSeenIf ? Boolean(canBeSeenIf) : canBeSeenIf === undefined).map(({ title, href, isExternalURL = false }, idx) => (
                                            <React.Fragment key={`acco-content-${idx}`}>
                                                <div className={(showingNavigationDropdown ? 'block' : 'hidden') + ' sm:hidden'}>
                                                    <Dropdown.ResponsiveLink hasExternalURL={isExternalURL} href={href} method={method}>
                                                        {title}
                                                    </Dropdown.ResponsiveLink>
                                                </div>
                                                <div className="hidden sm:flex">
                                                    <Dropdown.Link hasExternalURL={isExternalURL} href={href} method={method}>
                                                        {title}
                                                    </Dropdown.Link>
                                                </div>
                                            </React.Fragment>
                                        ))}
                                    </Accordion.Content>
                                </Accordion.Panel>
                            </Accordion>
                        </div>
                        <div className="hidden items-center justify-center sm:flex px-4 py-2 sm:px-0 sm:py-0">
                            <Dropdown>
                                <Dropdown.Trigger>
                                    <span className="inline-flex rounded-md">
                                        <button
                                            type="button"
                                            className="inline-flex items-start sm:items-center border border-transparent text-base sm:text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition ease-in-out duration-150"
                                        >
                                            {link.title}
                                            <svg
                                                className="ml-2 -mr-0.5 h-4 w-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </button>
                                    </span>
                                </Dropdown.Trigger>
                                <Dropdown.Content>
                                    {link.dropdown.filter(({canBeSeenIf}) => canBeSeenIf ? Boolean(canBeSeenIf) : canBeSeenIf === undefined).map(({ title, href, isExternalURL = false }, index) => (
                                        <React.Fragment key={`acco-cont-${index}`}>
                                            <div className={(showingNavigationDropdown ? 'block' : 'hidden') + ' sm:hidden'}>
                                                <Dropdown.ResponsiveLink hasExternalURL={isExternalURL} href={href} method={method}>
                                                    {title}
                                                </Dropdown.ResponsiveLink>
                                            </div>
                                            <div className="hidden sm:flex">
                                                <Dropdown.Link hasExternalURL={isExternalURL} href={href} method={method}>
                                                    {title}
                                                </Dropdown.Link>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </Dropdown.Content>
                            </Dropdown>
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment key={`navlink-${i}`}>
                        <div className={(showingNavigationDropdown ? 'block' : 'hidden') + ' sm:hidden'}>
                            <ResponsiveNavLink method={method} href={link.href} hasExternalLink={link?.isExternalURL}>
                                {link.title}
                            </ResponsiveNavLink>
                        </div>
                        <div className="hidden sm:flex">
                            <NavLink method={method} href={link.href} hasExternalLink={link?.isExternalURL}>
                                {link.title}
                            </NavLink>
                        </div>
                    </React.Fragment>
                )
            )}
        )
    }

    return (
        <div className="min-h-screen bg-gray-100">
            <nav className="bg-white border-b border-gray-100">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16">
                        <div className="flex">
                            <div className="flex-shrink-0 flex items-center">
                                <Link href="/dashboard">
                                    <ApplicationLogo store={store} isLarge={false} />
                                </Link>
                            </div>
                            <div className="hidden space-x-8 sm:-my-px sm:ml-10 sm:flex">
                                <LinkList />
                                {branchOffices && isSuperAdmin && (
                                    <Select className="self-center"
                                        options={branchOffices.map(e => ({
                                            value:e.slug,
                                            label: e.name
                                        }))}
                                        styles={{
                                            indicatorSeparator: () => ({ display: "none" }),
                                            input: (styles) => ({
                                                ...styles,
                                                "> input": {
                                                    boxShadow: "none !important",
                                                },
                                            }),
                                        }}
                                        noOptionsMessage={() =>
                                            "No hay administradores en el sistema"
                                        }
                                        placeholder={branchOffice.name}
                                        onChange={(e) => {
                                            return Inertia.visit(`/${e.value}/schedule`)
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="hidden sm:flex sm:items-center sm:ml-6">
                            <div className="ml-3 relative">
                                <Dropdown>
                                    {
                                    
                                    <Dropdown.Trigger>
                                        <span className="inline-flex rounded-md">
                                            <button
                                                type="button"
                                                className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition ease-in-out duration-150"
                                            >
                                                {auth.user.name}
                                                <svg
                                                    className="ml-2 -mr-0.5 h-4 w-4"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 20 20"
                                                    fill="currentColor"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                        clipRule="evenodd"
                                                    />
                                                </svg>
                                            </button>
                                        </span>
                                    </Dropdown.Trigger>
                                    }

                                    {/* {
                                    !branchOffice && isValidator &&
                                    <Dropdown.Trigger>
                                        <span className="inline-flex rounded-md">
                                            <button
                                                type="button"
                                                className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition ease-in-out duration-150"
                                            >
                                                {auth.user.name}
                                                <svg
                                                    className="ml-2 -mr-0.5 h-4 w-4"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 20 20"
                                                    fill="currentColor"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                        clipRule="evenodd"
                                                    />
                                                </svg>
                                            </button>
                                        </span>
                                    </Dropdown.Trigger>
                                    } */}

                                    <Dropdown.Content>
                                        {
                                            isSuperAdmin && <Dropdown.Link href={route('branch-office.index')} method="get">
                                                Sucursales
                                            </Dropdown.Link>
                                        }
                                        {
                                            isSuperAdmin && <Dropdown.Link href={route('bulk-dte.index')} method="get">
                                                Plugin DTE
                                            </Dropdown.Link>
                                        }
                                        {
                                            isSuperAdmin && <Dropdown.Link href={route('users.index')} method="get">
                                                Usuarios
                                            </Dropdown.Link>
                                        }
                                        {/* {
                                            isSuperAdmin && <Dropdown.Link href={route('config.index')} method="get">
                                                Configuración
                                            </Dropdown.Link>
                                        } */}
                                        <Dropdown.Link href={route('logout')} method="post" as="button">
                                            Log Out
                                        </Dropdown.Link>
                                    </Dropdown.Content>
                                </Dropdown>
                            </div>
                        </div>

                        <div className="-mr-2 flex items-center sm:hidden">
                            <button
                                onClick={() => setShowingNavigationDropdown((previousState) => !previousState)}
                                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
                            >
                                <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                    <path
                                        className={!showingNavigationDropdown ? 'inline-flex' : 'hidden'}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M4 6h16M4 12h16M4 18h16"
                                    />
                                    <path
                                        className={showingNavigationDropdown ? 'inline-flex' : 'hidden'}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div className={(showingNavigationDropdown ? 'block' : 'hidden') + ' sm:hidden'}>
                    <div className="pt-2 pb-3 space-y-1">

                        <LinkList />

                        {branchOffices && isSuperAdmin && (
                            <Select className="self-center px-4 max-w-xs"
                                options={branchOffices.map(e => ({
                                    value:e.slug,
                                    label: e.name
                                }))}
                                styles={{
                                    indicatorSeparator: () => ({ display: "none" }),
                                    input: (styles) => ({
                                        ...styles,
                                        "> input": {
                                            boxShadow: "none !important",
                                        },
                                    }),
                                }}
                                noOptionsMessage={() =>
                                    "No hay administradores en el sistema"
                                }
                                placeholder={branchOffice.name}
                                onChange={(e) => {
                                    return Inertia.visit(`/${e.value}/schedule`)
                                }}
                            />
                        )}

                        {
                            isSuperAdmin && (
                                <div className="block sm:hidden sm:flex px-4 py-2 sm:px-0 sm:py-0">
                                    <Accordion>
                                        <Accordion.Panel className="gap-2 items-center text-gray-500" title={auth.user.name}>
                                            <Accordion.Content>
                                                {
                                                    isSuperAdmin && <Dropdown.ResponsiveLink href={route('branch-office.index')} method="get">
                                                        Sucursales
                                                    </Dropdown.ResponsiveLink>
                                                }
                                                {
                                                    isSuperAdmin && <Dropdown.ResponsiveLink href={route('bulk-dte.index')} method="get">
                                                        Plugin DTE
                                                    </Dropdown.ResponsiveLink>
                                                }
                                                {
                                                    isSuperAdmin && <Dropdown.ResponsiveLink href={route('users.index')} method="get">
                                                        Usuarios
                                                    </Dropdown.ResponsiveLink>
                                                }
                                            </Accordion.Content>
                                        </Accordion.Panel>
                                    </Accordion>
                                </div>
                            )
                        }

                    </div>

                    <div className="pt-4 pb-1 border-t border-gray-200">
                        <div className="px-4">
                            <div className="font-medium text-base text-gray-800">{auth.user.name}</div>
                            <div className="font-medium text-sm text-gray-500">{auth.user.email}</div>
                        </div>

                        <div className="mt-3 space-y-1">
                            <ResponsiveNavLink method="post" href={route('logout')} as="button">
                                Log Out
                            </ResponsiveNavLink>
                        </div>
                    </div>
                </div>
            </nav>

            {header && (
                <header className="bg-white shadow">
                    <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">{header}</div>
                </header>
            )}

            <main>{children}</main>
        </div>
    );
}
